import {TileId} from '../models/tile';

export function filterByMatchingIds<T>(items: T[], getId: (item: T) => TileId, matchingIds: Set<TileId> | null): T[] {
  return matchingIds ? items.filter(item => matchingIds.has(getId(item))) : items;
}

export function setsHaveSameMembers(a: Set<TileId> | null, b: Set<TileId> | null): boolean {
  if (a === b) {
    return true;
  }
  if (!a || !b || a.size !== b.size) {
    return false;
  }
  for (const id of a) {
    if (!b.has(id)) {
      return false;
    }
  }
  return true;
}
